import { PERMISSION_TO_TEXT } from '../constants/permissions.constants';

export const CLARIFICATION_STAKEHOLDERS_RESOURCE = {
  key: 'CLARIFICATION_STAKEHOLDERS_RESOURCE',
  table: {
    title: 'Betrokkenen',
    emptyMessage: 'Er zijn momenteel nog geen betrokkenen toegevoegd.',
    defaultSort: 'firstname',
    dataLocation: '_embedded.static',
    disablePagination: true,
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i,
        organization: i?.organisationName ?? '',
        organizationRole: PERMISSION_TO_TEXT?.[i?.organisationRole] ?? ''
      })),
    // pageMapping: PAGINATION_MAPPINGS.DOSSIERS,
    fields: [
      { value: 'firstname', label: 'Voornaam', show: true, order: 0 },
      { value: 'lastname', label: 'Familienaam', show: true, order: 1 },
      {
        value: 'email',
        label: 'E-mail',
        show: true,
        order: 2
      },
      { value: 'organization', label: 'Organisatie', show: true, order: 3 },
      { value: 'organizationRole', label: 'Rechten', show: true, order: 4 },
      { value: 'role', label: 'Rol', show: true, order: 5 }
    ]
  }
};
